<script>
  import theader from "./components/theader.vue";

  import tfooter from "./components/tfooter.vue";

  import VueHead from 'vue-head';

  export default {
    name: "App",
    components: {
      theader,
      tfooter
    },
    data() {
      return {
        msg: "Welcome to Your Vue.js App"
      };
    },
    mounted() {
      window.prerenderReady = window.prerenderReady || true;
    }
  };
</script>

<template>
  <div id="app">
    <theader v-if="$route.name != 'candidate' && $route.name != 'receipt' && $route.name != 'deposit'" />
    <router-view />
    <tfooter v-if="$route.name != 'receipt'" />
  </div>
</template>

<style lang="scss">
@import url('../stylesheets/_main.scss');
.container {
  position: relative;

  padding-right: 1rem;
  padding-left: 1rem;
  margin: auto;

  @media (min-width: 768px) {
    max-width: 720px;

    padding-right: 2rem;
    padding-left: 2rem;
  }

  @media (min-width: 991px) {
    max-width: 940px;
  }

  @media (min-width: 1200px) {
    max-width: 1200px;
  }

  &:after {
    clear: both;

    display: table;

    content: '';
  }

}

.row {
  position: relative;

  width: 100%;

  margin: auto;
}

.section {
  padding-top: 3.125rem;
  padding-bottom: 3.125rem;

  @media (min-width: 768px) {
    padding-top: 4.375rem;
    padding-bottom: 4.375rem;
  }

  @media (min-width: 991px) {
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  @media (min-width: 1200px) {
    padding-top: 12.5em;
    padding-bottom: 12.5em;
  }

  &::after {
    clear: both;

    display: table;

    content: '';

  }
}

.wrap-info {
  position: relative;

  &--6 {
    float: left;

    width: 48%;

    margin-right: 1%;
    margin-left: 1%;

    @media (max-width: 768px) {
      width: 100%;

      margin-bottom: 1.25rem;
    }
  }

  &--7 {
    float: left;

    width: 56.33%;

    margin-right: 1%;
    margin-left: 1%;

    @media (max-width: 768px) {
      width: 100%;

      margin-bottom: 1.25rem;
    }
  }

  &--9 {
    float: left;

    width: 73%;

    margin-right: 1%;
    margin-left: 1%;

    @media (max-width: 768px) {
      width: 100%;

      margin-bottom: 1.25rem;
    }
  }

  &--text {
    width: 80%;

    text-align: left;
  }
}

.btn {
  display: block;

  width: 335px;
  max-width: 100%;

  padding: 22px 0;
  margin: 10px 0;

  text-align: center;

  color: #ffffff;

  border-radius: 8px;

  opacity: 0.9;

  &-white-opacity {
    background: rgba(255, 255, 255, 0.35);

    &:hover {
      background: rgba(255, 255, 255, 0.5);
    }
  }

  &-green {
  background-color: #4bb958;

    &:hover {
      color: #ffffff;

      background-color: #55d164;
    }
  }
}

.img-full {
  display: block;

  width: 100%;
}

img {
  max-width: 100%;
}

.text {
  &-bold {
    font-weight: bold;
  }

  &-blue {
    color: #2c3e50;
  }

  &-green {
    color: #4bb958;
  }
}

.clear-fix {
  clear: both;

  display: table;

  content: '';

}

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: normal;

    text-align: left;
    }

h1 {
  font-weight: normal;
  font-size: 2.2em;

  text-transform: uppercase;

  @media (min-width: 500px) {
    font-size: 3em;
  }

  @media (min-width: 1200px) {
    font-size: 4em;
  }
}

h2 {
  font-weight: bold;
  font-size: 35px;
  letter-spacing: -1.2px;

  @media (min-width: 500px) {
    font-size: 38px;
  }

  @media (min-width: 1200px) {
    font-size: 48px;

  }
}



.big-title {
  font-size: 40px;

  @media (min-width: 500px) {
    font-size: 48px;
  }

  @media (min-width: 1200px) {
    font-size: 58px;
  }
}

h3 {
  font-size: 16px;

  @media (min-width: 380px) {
    font-size: 17px;
  }

  @media (min-width: 1200px) {
    font-size: 18px;
  }
}

p {
  font-weight: normal;
  font-size: 16px;
  line-height: 1.5;
}


li {
  font-size: 16px;

  @media (min-width: 380px) {
    font-size: 17px;
  }

  @media (min-width: 1200px) {
    font-size: 18px;
  }
}

.huge-title {
  font-size: 50px;

  @media (min-width: 500px) {
    font-size: 70px;
  }

  @media (min-width: 1200px) {
    font-size: 80px;
  }
}

.title {
  display: block;

  padding: 0;
  margin: 0;

  font-weight: bold;

  color: rgb(53, 211, 79);
}

.block-element {
  display: block;
}

.to-right {
  float: right;
}

.date-warning {
  position: absolute;
  left: 50%;

  display: block;

  min-width: 10em;

  padding: 0.5em;

  font-size: 15px;

  color: white;

  background-color: #203f57;

  border-radius: 8px;

  opacity: 0;
  transform: translateX(-50%);

  transition-duration: 1s;
  transition-property: opacity;

  &::before {
    position: absolute;
    top: -6px;
    left: 50%;

    width: 0;
    height: 0;

    margin-left: -3px;

    border-width: 0 6px 6px 6px;
    border-style: solid;
    border-color: transparent transparent #203f57 transparent;

    content: '';
  }

  :hover > &,
  :focus > & {
      opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// _source/javascript/App.vue